// keycloak.js
import Keycloak from 'keycloak-js'

const keycloakConfig = {
  url:
    process.env.REACT_APP_KEYCLOAK_URL ||
    'https://tdis-authx-dev.azurewebsites.net',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'DMQT',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'tdis-catalog-search',
}

const keycloak = new Keycloak(keycloakConfig)
let initPromise = null

export const ensureKeycloakInitialized = (options = { onLoad: 'none' }) => {
  if (!initPromise) {
    initPromise = keycloak
      .init({
        onLoad: options.onLoad,
        pkceMethod: 'S256',
        promiseType: 'native',
        silentCheckSsoRedirectUri:
          window.location.origin + '/silent-check-sso.html',
        checkLoginIframe: false,
        silent: true,
      })
      .then((authenticated) => {
        keycloak.initialized = true
        if (authenticated) {
          sessionStorage.setItem('keycloakAuthenticated', 'true')
          // Set up token refresh
          setInterval(() => {
            keycloak.updateToken(70).catch(() => {
              keycloak.logout()
            })
          }, 60000) // Check every minute
        } else {
          sessionStorage.removeItem('keycloakAuthenticated')
        }
        return authenticated
      })
      .catch((error) => {
        sessionStorage.removeItem('keycloakAuthenticated')
        throw error
      })
  }
  return initPromise
}

export const initializeKeycloak = (onAuthenticatedCallback) => {
  ensureKeycloakInitialized({ onLoad: 'check-sso' })
    .then((authenticated) => {
      onAuthenticatedCallback(authenticated)
    })
    .catch(() => {
      onAuthenticatedCallback(false)
    })
}

export const loginUser = () => {
  ensureKeycloakInitialized({ onLoad: 'check-sso' })
    .then((authenticated) => {
      if (authenticated) {
        // If already authenticated, just update the session
        sessionStorage.setItem('keycloakAuthenticated', 'true')
      } else {
        // If not authenticated, try silent login first
        keycloak
          .login({ silent: true })
          .then(() => {
            sessionStorage.setItem('keycloakAuthenticated', 'true')
          })
          .catch(() => {
            // Only show login prompt if silent login fails
            keycloak.login()
          })
      }
    })
    .catch(() => {
      // If there's an error, try silent login first
      keycloak
        .login({ silent: true })
        .then(() => {
          sessionStorage.setItem('keycloakAuthenticated', 'true')
        })
        .catch(() => {
          // Only show login prompt if silent login fails
          keycloak.login()
        })
    })
}

export const isUserAuthenticated = () =>
  keycloak.authenticated &&
  sessionStorage.getItem('keycloakAuthenticated') === 'true'

export const isTokenValid = () => keycloak.token && !keycloak.isTokenExpired()

export const logoutUser = () => {
  // Clear all session storage
  sessionStorage.clear()
  // Clear any local storage if used
  localStorage.clear()
  // Call keycloak logout with proper redirect
  keycloak.logout({
    redirectUri: window.location.origin,
    silent: true, // This will prevent the redirect to Keycloak's logout page
  })
}

export default keycloak
